import { FC, HTMLAttributes, memo } from 'react'

// use https://jakearchibald.github.io/svgomg/ to optimize SVGs
const variants = {
  caret: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-1 -2 8 8"
      className="Icon-glyph"
    >
      <title>Caret icon</title>
      <path d="M.707 0 0 .697 3.354 4 6.707.697 6 0 3.359 2.602z" />
    </svg>
  ),
  close: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
      className="Icon-glyph"
    >
      <title>Close icon</title>
      <path
        fill="#151515"
        d="m15.577.808 1.23 1.23-6.77 6.77 6.77 6.769-1.23 1.23-6.77-6.77-6.769 6.77-1.23-1.23 6.769-6.77-6.77-6.769L2.039.808l6.77 6.77 6.769-6.77z"
      />
    </svg>
  ),
  filter: (
    <svg fill="#0157FF" viewBox="0 0 16 12" className="Icon-glyph">
      <title>Filter icon</title>
      <path d="M9 10v2H7v-2h2zm3-5v2H4V5h8zm4-5v2H0V0h16z" />
    </svg>
  ),
  arrow: (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        d="M20 12L13.8863 18L12.3579 16.5L15.7204 13.2H3V10.8H15.7204L12.3579 7.5L13.8863 6L20 12Z"
        className="Icon-glyph"
        fill="currentColor"
      ></path>
      <title>Arrow Right</title>
    </svg>
  ),
  error: (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.62 18.1431L12.743 4.50016C12.6552 4.34815 12.529 4.22191 12.377 4.13415C11.8987 3.858 11.2871 4.02187 11.011 4.50016L3.13398 18.1431C3.04621 18.2951 3 18.4675 3 18.6431C3 19.1954 3.44772 19.6431 4 19.6431H19.7539C19.9295 19.6431 20.1019 19.5969 20.254 19.5091C20.7322 19.233 20.8961 18.6214 20.62 18.1431ZM19.7539 18.6431H4L11.877 5.00017L19.7539 18.6431ZM12.877 16.3931C12.877 16.9454 12.4293 17.3931 11.877 17.3931C11.3247 17.3931 10.877 16.9454 10.877 16.3931C10.877 15.8408 11.3247 15.3931 11.877 15.3931C12.4293 15.3931 12.877 15.8408 12.877 16.3931ZM12.8532 10.3719C12.8532 9.83132 12.4149 9.39309 11.8744 9.39309C11.8431 9.39309 11.8118 9.39457 11.7806 9.39754C11.2372 9.4493 10.8387 9.93177 10.8904 10.4752L11.208 13.8094C11.2396 14.1403 11.5175 14.3931 11.85 14.3931C12.1832 14.3931 12.4627 14.1414 12.4975 13.81L12.8478 10.4741C12.8514 10.4402 12.8532 10.406 12.8532 10.3719Z"
        fill="currentColor"
      ></path>
      <title>Error</title>
    </svg>
  ),
  globeWorld: (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.9997 20.8515L25.3377 18.1505C26.6987 16.4255 22.2297 21.0495 23.9507 19.5905L25.1647 20.8225C20.5607 24.7745 13.6687 24.5765 9.36566 20.2115C4.82866 15.6065 4.85966 8.08151 9.43766 3.43751L10.1387 2.72551L7.45166 -0.000488281L6.04966 1.42351L7.35766 2.75151C2.69066 8.21251 2.88566 16.4835 7.96266 21.6355C10.3627 24.0695 13.4477 25.3855 16.6037 25.6105V29.9865H11.6417V31.9995H16.6037H18.5877H23.5487V29.9865H18.5877V25.6075C21.7587 25.3675 24.8717 24.0275 27.2987 21.5635L27.9997 20.8515Z"
        className="icon-highlight"
        fill="currentColor"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.5 12C27.5 17.5228 23.0228 22 17.5 22C11.9772 22 7.5 17.5228 7.5 12C7.5 6.47715 11.9772 2 17.5 2C23.0228 2 27.5 6.47715 27.5 12ZM19.1289 19.7617C19.1149 19.6197 19.1159 19.4607 19.1439 19.2877C19.2479 18.6397 19.6269 17.9977 20.0239 17.7967C21.5649 17.0147 21.5649 15.7087 21.5649 14.7557C21.5649 13.9337 21.5649 13.2837 22.2669 12.5727C22.8969 11.9317 23.6569 11.8517 24.1839 11.8897C24.7379 11.9337 25.1929 12.1237 25.5109 12.3287C25.2989 16.0277 22.6269 19.0647 19.1289 19.7617ZM11.8379 16.1937C11.6529 15.6317 11.0019 15.0337 10.2189 14.8177C10.5149 15.5757 10.9189 16.2807 11.4159 16.9067C11.6309 16.8197 11.7949 16.7137 11.8499 16.6007C11.9099 16.4787 11.8759 16.3127 11.8379 16.1937ZM17.5959 3.8047C18.2889 3.8047 19.0169 4.5007 19.1059 5.0497L19.1059 5.04985C19.1259 5.17699 19.1866 5.56182 18.2739 5.8707C16.9129 6.3297 16.1079 6.8097 15.4599 7.1967L15.4543 7.20005C14.745 7.62082 14.3879 7.8327 13.6259 7.8327C12.9039 7.8327 12.4679 7.5987 11.9619 7.3257C11.7549 7.2157 11.5279 7.0977 11.2819 6.9957C12.7329 5.0617 15.0199 3.8047 17.5959 3.8047ZM24.3389 9.8817C24.6779 9.9087 25.0079 9.9817 25.3309 10.0747C24.7899 7.6617 23.1799 5.6627 21.0329 4.6107C21.0365 4.62823 21.0421 4.64555 21.0477 4.66295C21.0547 4.68426 21.0616 4.70568 21.0649 4.7277C21.1469 5.2437 21.2349 6.9917 18.9009 7.7807C17.7379 8.1747 17.0619 8.5767 16.4639 8.9337C15.6749 9.4037 14.9299 9.8467 13.6259 9.8467C12.4145 9.8467 11.617 9.41981 11.0362 9.10891L11.0339 9.1077C10.6779 8.9167 10.4669 8.8187 10.2589 8.7907C9.8729 9.7377 9.6569 10.7737 9.6569 11.8607C9.6569 12.1557 9.6749 12.4457 9.7059 12.7327C11.5459 12.7687 13.2199 14.0337 13.7209 15.5577C13.9459 16.2437 13.9129 16.9157 13.6239 17.5007C13.4979 17.7587 13.2659 18.0647 12.9059 18.3457C14.1099 19.2447 15.5709 19.8047 17.1569 19.8937C17.1329 19.5957 17.1339 19.2877 17.1859 18.9657C17.3949 17.6567 18.1609 16.4897 19.1359 15.9947C19.5379 15.7907 19.5799 15.6747 19.5799 14.7557C19.5799 13.7827 19.5799 12.4507 20.8629 11.1487C21.7729 10.2267 23.0029 9.7707 24.3389 9.8817Z"
        className="icon-base"
        fill="currentColor"
      ></path>
      <title>Globe World</title>
    </svg>
  ),
  mortgageReviews: (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.999 -0.000488281L11 5.00051V1.00051H10.995H3.999L4 12.0005H3.999L0 15.9995L1.454 17.4545L3.999 14.9075L3.998 31.9995H19L18.992 30.0005H12.998L12.999 19.0005H19L18.999 22.0005H20.998L20.999 16.9485L11 16.9995V30.0005H5.998L5.999 12.9095L16 2.90851L25.999 12.9085V19.0005H27.999V14.9075L30.545 17.4545L31.999 15.9995L16 0.00151172L15.999 -0.000488281ZM5.999 3.00051H9.001L9 6.99951L5.999 10.0015V3.00051Z"
        className="icon-base"
        fill="currentColor"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.145 23.9505L19 24.5845L21.999 27.6585L21.291 32.0005L24.999 29.9495L28.707 32.0005L28 27.6585L30.999 24.5845L26.853 23.9505L24.999 20.0005L23.145 23.9505ZM23.48 27.8995L23.601 27.1525L23.073 26.6105L22.112 25.6255L23.372 25.4325L24.163 25.3125L24.503 24.5875L24.999 23.5305L25.496 24.5875L25.835 25.3125L26.627 25.4325L27.887 25.6255L26.926 26.6105L26.397 27.1525L26.519 27.8995L26.73 29.1925L25.725 28.6375L24.999 28.2365L24.274 28.6375L23.269 29.1925L23.48 27.8995Z"
        className="icon-highlight"
        fill="currentColor"
      ></path>
      <title>Mortgage Reviews</title>
    </svg>
  ),
  mortgageMarket: (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21H26V12H12V21ZM10 23H28V10H10V23Z"
        className="icon-highlight"
        fill="currentColor"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0V4H0V6H4V32H6V6H32V4H6V0H4Z"
        className="icon-base"
        fill="currentColor"
      ></path>
      <title>Mortgage Market</title>
    </svg>
  ),
  user: (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9C9 5.14 12.141 2 16 2C19.859 2 23 5.14 23 9C23 12.859 19.859 16 16 16C12.141 16 9 12.859 9 9ZM24.5 18.447C23.3137 17.7018 22.0226 17.1078 20.654 16.692C23.256 15.114 25 12.265 25 9C25 4.029 20.971 0 16 0C11.029 0 7 4.029 7 9C7 12.266 8.745 15.115 11.348 16.693C5.361 18.497 0.791 23.672 0 30.001V32H20.2812L20.5859 30H2.159C3.135 23.227 8.961 18 16 18C18.82 18 21.4478 18.8379 23.6476 20.2779C23.6476 20.2779 24.5 18.5 24.5 18.447Z"
        className="icon-base"
        fill="currentColor"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.372 25.433L25.164 25.313L25.504 24.588L26 23.531L26.496 24.588L26.836 25.313L27.628 25.433L28.888 25.625L27.927 26.612L27.397 27.153L27.519 27.9L27.73 29.193L26.726 28.638L26 28.237L25.274 28.638L24.269 29.193L24.48 27.9L24.602 27.153L24.073 26.612L23.112 25.625L24.372 25.433ZM22.292 32L26 29.951L29.708 32L29 27.659L32 24.584L27.854 23.951L26 20L24.145 23.951L20 24.584L23 27.659L22.292 32Z"
        className="icon-highlight"
        fill="currentColor"
      ></path>
      <title>User</title>
    </svg>
  ),
  ribbon: (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12.4433L6.62975 9.81356L5.66705 6.22072L9.25983 5.25804L10.2222 1.66649L13.8144 2.62903L16.4435 0L19.0731 2.62965L22.6656 1.66705L23.6281 5.25931L27.2198 6.2217L26.2573 9.81395L28.8868 12.4435L26.2571 15.0731L27.2197 18.6656L23.628 19.628L22.9587 22.1257V32L16.4434 29.2359L9.92804 32V22.1261L9.25853 19.6274L5.66698 18.6651L6.62952 15.0728L4 12.4433ZM11.9328 22.7616V28.9718L16.4434 27.0582L20.954 28.9718V22.7612L19.0729 22.2572L16.4433 24.8868L13.8141 22.2575L11.9328 22.7616ZM16.4435 2.83511L18.474 4.86563L21.248 4.12233L21.9913 6.89616L24.7645 7.63925L24.0213 10.4131L26.0517 12.4435L24.0212 14.474L24.7645 17.248L21.9912 17.9911L21.248 20.7645L18.4738 20.0212L16.4433 22.0517L14.4132 20.0215L11.6388 20.7649L10.8954 17.9906L8.12225 17.2475L8.8655 14.4737L6.83511 12.4433L8.86573 10.4127L8.12233 7.63827L10.8967 6.89489L11.6397 4.12177L14.4136 4.86501L16.4435 2.83511Z"
        className="icon-base"
        fill="currentColor"
      ></path>
      <path
        d="M17.4823 16.3171C17.1511 16.4056 16.803 16.4528 16.4439 16.4528C14.2295 16.4528 12.4344 14.6577 12.4344 12.4434C12.4344 10.229 14.2295 8.43392 16.4439 8.43392C18.6582 8.43392 20.4533 10.229 20.4533 12.4434C20.4533 12.8026 20.4061 13.1508 20.3175 13.4821L21.8719 15.0364C22.2476 14.2513 22.458 13.3719 22.458 12.4434C22.458 9.12184 19.7654 6.4292 16.4439 6.4292C13.1223 6.4292 10.4297 9.12184 10.4297 12.4434C10.4297 15.7649 13.1223 18.4576 16.4439 18.4576C17.3723 18.4576 18.2516 18.2472 19.0367 17.8715L17.4823 16.3171Z"
        className="icon-highlight"
        fill="currentColor"
      ></path>
      <title>Ribbon</title>
    </svg>
  ),
  homelight: (
    <svg
      width="90"
      height="18"
      viewBox="0 0 90 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.73242 14.076L8.8427 8.27972L15.953 14.076C14.3442 16.2543 11.7587 17.6676 8.8427 17.6676C5.92698 17.6676 3.34117 16.2543 1.73242 14.076ZM7.12888 13.5542H8.597V12.086H7.12888V13.5542ZM9.08863 13.5542H10.5568V12.086H9.08863V13.5542ZM7.12888 15.5204H8.597V14.0523H7.12888V15.5204ZM9.08863 15.5204H10.5568V14.0523H9.08863V15.5204Z"
        fill="#273653"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0773 12.0361C17.4637 11.0433 17.6761 9.96328 17.6761 8.83378C17.6761 3.95494 13.7211 0 8.84257 0C3.96373 0 0.00878906 3.95494 0.00878906 8.83378C0.00878906 9.96328 0.221133 11.0433 0.60757 12.0361L8.84257 5.32322L17.0773 12.0361Z"
        fill="#46B6FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84242 5.32318L0.607422 12.0361C0.892609 12.7687 1.2723 13.4533 1.73214 14.076L8.84242 8.27968L15.9527 14.076C16.4123 13.4533 16.7922 12.7687 17.0771 12.0361L8.84242 5.32318Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.607422 12.0361C0.892609 12.7685 1.2723 13.4533 1.73214 14.076L8.84242 8.27974L15.9527 14.076C16.4123 13.4533 16.7922 12.7685 17.0771 12.0361L8.84242 5.32324L0.607422 12.0361Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8981 13.494V8.89669H23.0391V13.494H21.792V3.83897H23.0391V7.7849H28.8981V3.83897H30.1451V13.494H28.8981ZM37.7433 9.85808C37.7433 8.38602 36.8869 7.06386 35.3394 7.06386C33.7923 7.06386 32.9359 8.38602 32.9359 9.85808C32.9359 11.3456 33.7923 12.6675 35.3394 12.6675C36.8869 12.6675 37.7433 11.3456 37.7433 9.85808ZM31.749 9.85808C31.749 7.75489 33.1313 6.05727 35.3394 6.05727C37.5478 6.05727 38.9302 7.75489 38.9302 9.85808C38.9302 11.9616 37.5478 13.6741 35.3394 13.6741C33.1313 13.6741 31.749 11.9616 31.749 9.85808ZM49.1619 13.494V8.56622C49.1619 7.6499 48.7713 7.06378 47.8249 7.06378C47.0739 7.06378 46.2774 7.58972 45.902 8.17556V13.494H44.7753V8.56622C44.7753 7.6499 44.3995 7.06378 43.4382 7.06378C42.7022 7.06378 41.9209 7.6049 41.5302 8.19075V13.494H40.4035V6.23775H41.5302V7.28906C41.8458 6.82359 42.8071 6.05747 43.8888 6.05747C44.9856 6.05747 45.6165 6.65822 45.8269 7.40943C46.2324 6.7485 47.2089 6.05747 48.2608 6.05747C49.5827 6.05747 50.2889 6.7935 50.2889 8.25065V13.494H49.1619ZM55.3121 6.98871C53.7646 6.98871 52.9982 8.29568 52.9386 9.39256H57.7007C57.6858 8.32578 56.9647 6.98871 55.3121 6.98871ZM51.7517 9.85803C51.7517 7.75484 53.2539 6.05721 55.3273 6.05721C57.5207 6.05721 58.8125 7.77003 58.8125 9.94831V10.2338H52.9532C53.0438 11.6007 53.9899 12.7428 55.5523 12.7428C56.3938 12.7428 57.2201 12.4121 57.8059 11.811L58.3468 12.5473C57.6107 13.2685 56.6339 13.6743 55.4623 13.6743C53.2992 13.6743 51.7517 12.1269 51.7517 9.85803ZM60.301 13.494V3.83897H61.548V12.3822H66.205V13.494H60.301ZM67.3795 13.494V6.23775H68.5062V13.494H67.3795ZM67.1841 4.44984C67.1841 4.02909 67.5297 3.68372 67.9502 3.68372C68.3709 3.68372 68.7014 4.02909 68.7014 4.44984C68.7014 4.87031 68.3709 5.20106 67.9502 5.20106C67.5297 5.20106 67.1841 4.87031 67.1841 4.44984ZM75.6316 11.4055V8.22062C75.226 7.60468 74.3547 7.06383 73.4682 7.06383C71.9958 7.06383 71.1245 8.22062 71.1245 9.82824C71.1245 11.4207 71.9958 12.5775 73.4682 12.5775C74.3547 12.5775 75.226 12.0366 75.6316 11.4055ZM70.3584 15.3416L70.9291 14.5305C71.5301 15.2364 72.2512 15.507 73.2879 15.507C74.4897 15.507 75.6316 14.9211 75.6316 13.3889V12.2917C75.0907 13.0283 74.2045 13.5841 73.1827 13.5841C71.2896 13.5841 69.9528 12.1719 69.9528 9.82824C69.9528 7.49949 71.2747 6.05724 73.1827 6.05724C74.1592 6.05724 75.0457 6.5379 75.6316 7.33412V6.23752H76.7583V13.3889C76.7583 15.6872 75.0606 16.4385 73.2879 16.4385C72.0712 16.4385 71.2297 16.198 70.3584 15.3416ZM83.5379 13.494V8.7164C83.5379 7.42434 82.8918 7.06378 81.9004 7.06378C81.0291 7.06378 80.1876 7.6049 79.7672 8.19075V13.494H78.6405V3.83897H79.7672V7.28906C80.2627 6.6734 81.2544 6.05747 82.351 6.05747C83.8683 6.05747 84.6648 6.7935 84.6648 8.37103V13.494H83.5379ZM86.8156 11.9765V7.22929H85.6139V6.23761H86.8156V3.83883H87.9575V6.23761H89.4296V7.22929H87.9575V11.7363C87.9575 12.2769 88.1977 12.6675 88.6784 12.6675C89.0088 12.6675 89.2943 12.5174 89.4448 12.352L89.7749 13.2084C89.4898 13.479 89.0839 13.6741 88.4382 13.6741C87.3565 13.6741 86.8156 13.0582 86.8156 11.9765Z"
        fill="#273653"
      />
    </svg>
  )
}

interface Props extends HTMLAttributes<HTMLSpanElement> {
  variant: keyof typeof variants
}

const Icon: FC<Props> = ({ className = '', variant, ...rest }) => {
  return (
    <span className={`Icon ${className}`} {...rest}>
      {variants[variant]}
    </span>
  )
}

export default memo(Icon)
